import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BmCreditorBankAccountBaseComponentBase} from "../bm-creditor-bank-account-base.component-base";

// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'bm-creditor-bank-account-full',
    templateUrl: 'bm-creditor-bank-account-full.component.html',
    styleUrls: ['bm-creditor-bank-account-full.component.scss'],
    standalone: false
})
export class BmCreditorBankAccountFullComponent extends BmCreditorBankAccountBaseComponentBase implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized


    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }



    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
